import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import "../../components/CreateQuiz/CreateQuiz.css";
import QuizGenie from "../../assets/images/QuizGenie.png";
import { loginTutor, getTutorInformation, loginLearner } from "../../api/api";
import { jwtDecode } from "jwt-decode";
import LoaderModal from "../../components/LoaderModal";
import { motion } from 'framer-motion';

const LoginPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loginType, setLoginType] = useState('tutor');

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const tutorLogin = async () => {
        try {
            setLoader(true);
            const response = await loginTutor({ email: email, password: password });

            const token = response.accessToken;

            // Decode the JWT token
            const decodedToken = jwtDecode(token);
            const tutorId = decodedToken.id; // Extract the `id` field

            localStorage.setItem("token", token);
            localStorage.setItem("tutorId", tutorId);
            await getTutorInfo(tutorId);
            navigate('/question-creator');
        } catch (error) {
            alert(error.message)
        } finally {
            setLoader(false);
        }
    }

    const getTutorInfo = async (tutorId) => {
        try {

            const response = await getTutorInformation(tutorId);
            localStorage.setItem("tutorName", response.tutor.name);
            localStorage.setItem("tutorProfile", response.tutor.profilePicture)
        } catch (error) {
            alert(error.message)
        }

    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (loginType === "tutor") {
            await tutorLogin();
        } else {
            await learnerLogin();
        }
    };

    const learnerLogin = async () => {
        try {
            setLoader(true);
            const response = await loginLearner({ email: email, password: password });
            await onLogin(response);
            navigate('/learner');
        } catch (error) {
            alert("Please enter correct username and password");
        } finally {
            setLoader(false);
        }
    }

    const onLogin = (response) => {
        try {
            localStorage.setItem("learnerToken", response.token);
            localStorage.setItem("learnerId", response.learner.id);
            localStorage.setItem("learnerName", response.learner.name);
        } catch (error) {
            console.log("error", error);
        }

    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-500 to-indigo-700 text-white">
            {loader && <LoaderModal notLeftMargin={true} />}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white text-blue-600 p-8 rounded-lg shadow-xl max-w-md w-full mx-5"
            >
                <div className="flex justify-center">
                    <img src={QuizGenie} alt="QuizGenie Logo" className="h-16 mb-4 rounded-lg" />
                </div>
                <h2 className="text-2xl font-bold text-center">Welcome to QuizGenie</h2>
                <p className="text-center text-gray-600">Sign in as a {loginType === 'learner' ? 'Learner' : 'Tutor'}</p>

                <div className="flex justify-center my-4">
                    <button
                        className={`px-5 py-2 rounded-l-lg ${loginType === 'tutor' ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-700'}`}
                        onClick={() => setLoginType('tutor')}
                    >Tutor</button>
                    <button
                        className={`px-4 py-2 rounded-r-lg ${loginType === 'learner' ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-700'}`}
                        onClick={() => setLoginType('learner')}
                    >Learner</button>
                </div>

                <form className="mt-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-semibold">Email ID</label>
                        <input
                            type="email"
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Enter your email"
                        />
                    </div>
                    <div className="mb-4 relative">
                        <label className="block text-sm font-semibold">Password</label>
                        <input
                            type={showPassword ? "text" : "password"}
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Enter your password"
                        />
                        <span
                            onClick={togglePasswordVisibility}
                            className="absolute right-3 top-10 cursor-pointer text-gray-500"
                        >
                            {showPassword ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
                        </span>
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 rounded-md font-semibold text-lg hover:bg-blue-700 transition duration-300"
                    >
                        Log In as {loginType === 'learner' ? 'Learner' : 'Tutor'}
                    </button>
                </form>
                {/* <p className="text-center text-sm mt-4">
                    Don’t have an account? <Link to="/signup" className="text-blue-500 font-bold">Sign Up</Link>
                </p> */}
            </motion.div>
        </div>
    );
};

export default LoginPage;
